import Routings from './Routings'

function App() {
  return (
    <Routings></Routings>
  );
}

export default App;